import { Box, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { InfoIcon, useMinimalsTheme } from '@tom-ui/ui'
import {
  DischargeListTableColumnsDto,
  LoadListTableColumnsDto,
} from '../../Stores/VesselVisitOrderListViewStore'

interface VisitDashboardTableDetailPanelProps {
  row: { original: DischargeListTableColumnsDto | LoadListTableColumnsDto }
}

export const VisitDashboardTableDetailPanel = ({ row }: VisitDashboardTableDetailPanelProps) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const { containerTare, grossWeight, notes, operationalInstructions } = row.original

  const netWeight =
    grossWeight != null && containerTare != null ? Math.max(0, grossWeight - containerTare) : null

  const renderItem = (
    title: string,
    value?: string | number | null,
    opts?: { minWidth?: number },
  ) => (
    <Stack spacing={1} minWidth={opts?.minWidth ?? 120}>
      <Typography variant='subtitle2'>{title}</Typography>
      <Typography variant='body2'>
        {typeof value === 'string' ? value.trim() || '-' : value ?? '-'}
      </Typography>
    </Stack>
  )

  return (
    <Box
      sx={{
        bgcolor: theme.palette.grey[100],
        borderTop: `1px solid ${theme.palette.divider}`,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Stack direction='row' spacing={5}>
        <Stack
          direction='row'
          p={3}
          sx={{ minWidth: 357, borderRight: `1px solid ${theme.palette.divider}` }}
        >
          <InfoIcon sx={{ mr: 1 }} />
          <Typography variant='subtitle2' fontWeight={600}>
            {t('additionalInformation', 'Additional information')}
          </Typography>
        </Stack>

        {/* Content */}
        <Stack direction='column' spacing={2} p={3} flex={1}>
          <Stack direction='row' spacing={4} flexWrap='wrap'>
            {renderItem(t('tareWeight', 'Tare weight'), containerTare)}
            {renderItem(t('netWeight', 'Net weight'), netWeight)}
          </Stack>

          <Stack direction='row' spacing={4} flexWrap='wrap'>
            <Stack minWidth={280}>
              {renderItem(t('controlRoomNotes', 'Control room notes'), notes, { minWidth: 280 })}
            </Stack>
            <Stack minWidth={280}>
              {renderItem(
                t('operationalInstructions', 'Operational instructions'),
                operationalInstructions,
                { minWidth: 280 },
              )}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}
